// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__BRnVc","header":"PatientBlock_header__2hGNO","label":"PatientBlock_label__2OdyU","option":"PatientBlock_option__2OKPd"};